import { useContext } from "react";
import NotificationContext from "../context/contexts/NotificationContext";

const useNotification = () => useContext(NotificationContext);

export default useNotification;
